import { nextTick } from 'vue';
import axios from '@/utils/axios';
import i18n from '@/i18n';
import { I18nKey } from '@/i18n/types';
import { I18nParamKey } from '@/router/types';
import { convertI18nKeyToI18nParamKey } from '@/utils/route';
// TODO: 引入项目所需的语言
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import dayjs from 'dayjs';

// 保存已经加载的多语言
const loadedI18nList: I18nKey[] = [];

/**
 * 更新多语言
 */
const loadI18nEffect = (i18nKey: I18nKey): void => {
  i18n.global.locale = i18nKey;

  // html lang 属性
  document.querySelector('html')?.setAttribute('lang', convertI18nKeyToI18nParamKey(i18nKey));

  // axios 请求头
  axios.defaults.headers.common['Accept-Language'] = i18nKey;

  // 更新 dayjs locale
  const dayjsLocalMap: {
    [key in I18nKey]: string;
  } = {
    enUS: 'en',
    zhCN: 'zh-cn',
    zhTW: 'zh-tw',
  };
  dayjs.locale(dayjsLocalMap[i18nKey]);
};

/**
 * 加载多语言文件
 */
export const loadI18nAsync = async (i18nKey: I18nKey): Promise<void> => {
  if (i18n.global.locale !== i18nKey) {
    if (!i18n.global.availableLocales.includes(i18nKey)) {
      const results = await Promise.all([
        import(/* webpackChunkName: "lang-[request]" */ `@/i18n/resources/${i18nKey}.ts`),
        import(/* webpackChunkName: "lang-[request]" */ `@/i18n/resources/${i18nKey}.json`),
      ]);

      i18n.global.setLocaleMessage(i18nKey, {
        ...results[0].default,
        ...results[1].default,
      });

      loadedI18nList.push(i18nKey);
    }

    loadI18nEffect(i18nKey);
  }

  return nextTick();
};

/**
 * 验证多语言是否正确
 */
export const checkI18nKey = (i18nKey: I18nKey | null): boolean => {
  if (i18nKey !== 'enUS' && i18nKey !== 'zhTW' && i18nKey !== 'zhCN') {
    return false;
  }

  return true;
};

/**
 * 将 url 多语言转换成多语言
 */
export const convertI18nParamKeyToI18nKey = (i18nParamKey: I18nParamKey | null): I18nKey => {
  switch (i18nParamKey) {
    case 'en-us':
      return 'enUS';
    case 'zh-tw':
      return 'zhTW';
    case 'zh-cn':
      return 'zhCN';
    default:
      console.error('i18nParamKey 匹配失败, 这是一个非常严重的错误, 请检查');
      return 'enUS';
  }
};

/**
 * 根据浏览器获取多语言 key
 */
export const getI18nKeyByBrowser = (): I18nKey => {
  const browserLanguage = navigator.language.toLocaleLowerCase();

  if (browserLanguage.includes('tw') || browserLanguage.includes('hk')) {
    return 'zhTW';
  }
  if (browserLanguage.includes('en')) {
    return 'enUS';
  }
  if (browserLanguage.includes('zh') || browserLanguage.includes('cn')) {
    return 'zhCN';
  }

  return 'enUS';
};
